/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useInput } from "hooks";
import AutocompleteFreeText from "components/AutocompleteFreeText";
import { WEB_PROMOTIONS_INCENTIVE_PREDICTIVE_TEXT } from "config";

export const IncentiveWebPromotionsTextBuilder = ({
  className,
  value = "",
  onChange = () => {},
}) => {
  const freeText = useInput("")
  const [incentiveText, setIncentiveText] = useState(value)

  const handleUpdateValue = (e) => {
    setIncentiveText(`${e}`);
  };

  useEffect(() => {
    onChange(incentiveText);
  }, [incentiveText])

  return (
    <div className={`${className} mt-1 py-2`}>
      <Title>Incentive Text Builder</Title>
      <Container className="mt-1">
        <div style={{ width: 240 }}>
          <AutocompleteFreeText
            label="Free Text"
            value={freeText.value}
            data={WEB_PROMOTIONS_INCENTIVE_PREDICTIVE_TEXT}
            onChange={(e) => {
              freeText.setValue(e);
              handleUpdateValue(e)
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
